/** Mirrors PROJECT_TYPES in backend/models.py.
 *
 *  `unit` matters: only a thesis and a volume are built out of chapters. An
 *  article or a research proposal is built out of paragraphs, and calling those
 *  "capitoli" misnames the work the author is actually doing.
 */

export const PROJECT_TYPES = [
  {
    id: "thesis",
    label: "Tesi",
    unit: "Capitolo",
    unitPlural: "Capitoli",
    article: "un",
    gender: "m",
    description: "Triennale, magistrale o dottorato.",
  },
  {
    id: "volume",
    label: "Volume",
    unit: "Capitolo",
    unitPlural: "Capitoli",
    article: "un",
    gender: "m",
    description: "Monografia o volume curato, articolato in capitoli.",
  },
  {
    id: "article",
    label: "Articolo scientifico",
    unit: "Paragrafo",
    unitPlural: "Paragrafi",
    article: "un",
    gender: "m",
    description: "Struttura IMRaD, per sottomissione a rivista.",
  },
  {
    id: "review",
    label: "Review / Rassegna",
    unit: "Paragrafo",
    unitPlural: "Paragrafi",
    article: "un",
    gender: "m",
    description: "Rassegna della letteratura, sistematica o narrativa.",
  },
  {
    id: "book_chapter",
    label: "Capitolo di volume",
    unit: "Paragrafo",
    unitPlural: "Paragrafi",
    article: "un",
    gender: "m",
    description: "Contributo per un volume collettaneo.",
  },
  {
    id: "proposal",
    label: "Progetto di ricerca",
    unit: "Paragrafo",
    unitPlural: "Paragrafi",
    article: "un",
    gender: "m",
    description: "Proposta per un bando competitivo.",
  },
];

const BY_ID = Object.fromEntries(PROJECT_TYPES.map((t) => [t.id, t]));

export const PROJECT_LABELS = Object.fromEntries(PROJECT_TYPES.map((t) => [t.id, t.label]));

export const projectType = (id) => BY_ID[id] || BY_ID.thesis;

/** Agrees an adjective with the unit's gender: "avviati" / "avviate". */
export const agree = (id, masculine, feminine) =>
  projectType(id).gender === "f" ? feminine : masculine;
export const unit = (id) => projectType(id).unit;
export const unitPlural = (id) => projectType(id).unitPlural;
/** "un capitolo" / "un paragrafo", for sentences. */
export const unitWithArticle = (id) => {
  const t = projectType(id);
  return `${t.article} ${t.unit.toLowerCase()}`;
};
export const isChaptered = (id) => ["thesis", "volume"].includes(id);
